'use strict';

module.exports = require('./lib')



//////////////////
// WEBPACK FOOTER
// ./~/promise/index.js
// module id = 488
// module chunks = 0